import { getResponseErrorStatusCode } from '../../../utils/get-response-error-status-code';
import { workstationsApiRoutes as routes } from './routes';
export function getWorkstationsApiV1(httpClient) {
    return {
        create: ()=>httpClient.post(routes.create(), undefined)
        ,
        getCurrent: ()=>httpClient.get(routes.getCurrent()).catch((error)=>{
                if (getResponseErrorStatusCode(error) === 404) return undefined;
                throw error;
            })
    };
}

//# sourceMappingURL=get-workstations-api.js.map